/* Veyra · lo traído de Audor · 2026-10-01
   Lo único que el CSS no puede hacer de las secciones nuevas: que un punto
   sobre la bolsa y su renglón de la lista sean EL MISMO estado (`vy-dentro`).

   Las pestañas de «Qué esperar» NO están aquí: son radios + CSS, como las de
   la PDP. Y sin este archivo `vy-dentro` sigue entera: todos los renglones y
   todos los puntos visibles, ninguno marcado. No se pierde un dato. */
(function () {
  'use strict';

  Array.prototype.forEach.call(document.querySelectorAll('[data-vy-dentro]'), function (reja) {
    var botones = reja.querySelectorAll('[data-vy-i]');
    if (!botones.length) return;

    function marcar(i) {
      Array.prototype.forEach.call(botones, function (b) {
        var es = b.getAttribute('data-vy-i') === i;
        if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', es ? 'true' : 'false');
        if (b.classList.contains('vy-dentro__r')) b.classList.toggle('vy-dentro__r--on', es);
      });
    }

    Array.prototype.forEach.call(botones, function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () { marcar(b.getAttribute('data-vy-i')); });
    });

    /* Arranca con el primero marcado: una lista sin ningún estado no enseña
       que los puntos se tocan. Es el único cambio que hace el JS al cargar. */
    marcar('1');
  });
})();

/* --- El sabor NO se cambia por JS, y está medido · 2026-10-05 ----------------
   Se escribió el salto sin recarga y SE REVIRTIÓ el mismo día. El motivo: la
   galería filtra las fotos por variante EN EL SERVIDOR (`image.variants`), así
   que mientras se mira Cinnamon Cacao la foto de Vanilla no existe en el DOM.
   El script cambiaba precio, ids y nombre, y dejaba la foto anterior puesta:
   un selector que miente sobre lo que estás comprando es peor que una recarga.

   Hoy las muestras de sabor son enlaces a `?variant=`, y el servidor pinta la
   página entera coherente: foto, precio, galería y título.

   La forma correcta de quitar la recarga, el día que se quiera, NO es parchear
   la galería desde JS: es la Section Rendering API —`?variant=X&section_id=…`—
   que es el patrón que este tema ya usa para el cajón de la bolsa. Pide
   rebindear los listeners del nodo reemplazado; no es un parche de diez líneas.
   -------------------------------------------------------------------------- */

/* --- El menú deslizante · traducido de `slide-tabs` (21st.dev) · 2026-10-06 ---
   Lo único que el CSS no puede: saber DÓNDE está el enlace que tocas. El resto
   —la curva, el radio, el color— es CSS, y sin este archivo el menú se queda
   con la píldora estática que Liquid ya puso en `aria-current`. No se pierde
   nada: se pierde el viaje.

   `framer-motion` no entra. Son dos `requestAnimationFrame` y un `transform`.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var lista = document.querySelector('[data-vy-tabs]');
  if (!lista) return;
  var pastilla = lista.querySelector('[data-vy-pastilla]');
  if (!pastilla) return;

  var enlaces = [].slice.call(lista.querySelectorAll('.vy-nav__link'));
  if (!enlaces.length) return;

  /* La píldora solo tiene sentido con puntero: en una lista que se toca, el
     hover no existe y el gesto sería un parpadeo al pulsar. */
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var reposo = lista.querySelector('.vy-nav__link[aria-current="page"]');
  var nav = lista.closest('.vy-nav');

  function colocar(el, visible) {
    if (!el) { pastilla.style.opacity = '0'; return; }
    var c = lista.getBoundingClientRect();
    var b = el.getBoundingClientRect();
    pastilla.style.width = Math.round(b.width + 24) + 'px';
    pastilla.style.height = Math.round(b.height + 12) + 'px';
    pastilla.style.transform = 'translate(' + Math.round(b.left - c.left - 12) + 'px,'
                             + Math.round(b.top - c.top - 6) + 'px)';
    pastilla.style.opacity = visible ? '1' : '0';
  }

  function volver() { colocar(reposo, !!reposo); }

  enlaces.forEach(function (a) {
    a.addEventListener('mouseenter', function () { colocar(a, true); });
    a.addEventListener('focus', function () { colocar(a, true); });
  });
  lista.addEventListener('mouseleave', volver);
  lista.addEventListener('focusout', function (ev) {
    if (!lista.contains(ev.relatedTarget)) volver();
  });

  /* Se coloca ANTES de encender la transición: si no, la píldora entra viajando
     desde la esquina superior izquierda en cada carga. Dos cuadros bastan —uno
     para aplicar la posición y otro para que el navegador la dé por inicial. */
  colocar(reposo, !!reposo);
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      if (nav) nav.classList.add('vy-nav--desliza');
    });
  });

  /* Al cambiar el ancho, las medidas de ayer no sirven. */
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(volver, 150);
  });
})();
